import { envVariables } from '@fabric-ui/utils';
import { AuthStorageKeys } from '@utils/localStorageAuthUtils.utils';
import { retrieveConnectionDetailsFromAuthConfig, ZidAuthLocalStorageKeys } from './tokenUtils';

export const overrideAccountAttribute = async (accountId: string): Promise<void> => {
  const authConfigStr = localStorage.getItem(AuthStorageKeys.authConfig);
  const accessToken = localStorage.getItem(ZidAuthLocalStorageKeys.accessToken);

  if (!authConfigStr) {
    throw new Error('Authentication configuration not found. Please ensure the user is signed in.');
  }
  if (!accessToken) {
    throw new Error('Authentication token not found in local storage. User may be signed out.');
  }

  const { zidTenantServiceDomain } = retrieveConnectionDetailsFromAuthConfig();

  const [tenant, ...restOfDomain] = zidTenantServiceDomain.split('.');
  const adminZidDomain = `${tenant}-admin.${restOfDomain.join('.')}`;

  const requestBody = {
    zidDomain: `https://${adminZidDomain}`,
    accountId,
    accessToken,
  };

  const response = await fetch(`${envVariables.VITE_WEBSERVER_API_URL}/auth-config/override-account-id`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
    body: new URLSearchParams(requestBody).toString(),
  });

  if (!response.ok) {
    const errorBody = await response.json();
    throw new Error(
      `Failed to switch account. Server responded with status ${response.status}: ${errorBody.message || response.statusText}`
    );
  }
};
